import {NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {IonicApp, IonicModule, FabContainer} from 'ionic-angular';
import {MyApp} from './app.component';
import {AppImageCache} from './app.imagecahe';

// import services

import {SelectionSearchService} from '../services/selection-search';

// end import services

// import Providers
import {Api} from '../providers/api';
import {ApiOffline} from '../providers/api-offline';
import {CartManager} from '../providers/cart-manager';
import {Settings} from '../providers/settings';
// end import Providers

// import Utils
import {ArrayUtils} from '../utils/array-utils';
// end import Utils


// import pages
import {CartPage} from '../pages/cart/cart';
//import {CategoriesPage} from '../pages/categories/categories';
import {ItemsPage} from '../pages/items/items';
import {ChangePasswordPage} from '../pages/change-password/change-password';
import {ForgotPasswordPage} from '../pages/forgot-password/forgot-password';
import {HomePage} from '../pages/home/home';
import {ItemPage} from '../pages/item-details/item-details';
import {LoginPage} from '../pages/login/login';
import {ClosedsalesPage} from '../pages/closedsales/closedsales';
import {BysalesrepPage} from '../pages/bysalesrep/bysalesrep';
import {TrendingproductsPage} from '../pages/trendingproducts/trendingproducts';

import {MyAccountPage} from '../pages/my-account/my-account';
import {MyOrderPage} from '../pages/my-order/my-order';
import {OrderConfirmPage} from '../pages/order-confirm/order-confirm';
import {RegisterPage} from '../pages/register/register';
import {SearchPage} from '../pages/search/search';
import {SettingsPage} from '../pages/settings/settings';
import {CategoriesTabsPage} from '../pages/categories-tabs/categories-tabs';

import {WelcomePage} from '../pages/welcome/welcome';
import {CustomerWishListPage} from '../pages/customer-wish-list/customer-wish-list';
import {SearchCustomersPage} from '../pages/search-customers/search-customers';
import {CreateCustomerPage} from '../pages/create-customer/create-customer';
import {ListCustomersPage} from '../pages/list-customers/list-customers';
import {CustomerDetailPage} from '../pages/customer-detail/customer-detail';
import {EditCustomerPage} from '../pages/edit-customer/edit-customer';
import {OrderViewPage} from '../pages/order-view/order-view';
import {DashBoardPage} from '../pages/dash-board/dash-board';
import {SelectionSearchPage} from '../pages/selection-search/selection-search';

import {WebstoreUsersPage} from '../pages/webstore-users/webstore-users';
import {WebstoreUserAddPage} from '../pages/webstore-user-add/webstore-user-add';
import {WebstoreUserAddPopup} from '../pages/webstore-user-add-popup/webstore-user-add-popup';
import {CategoriesPage} from '../pages/categories/categories';
import {ClassesPage} from '../pages/classes/classes';
import {UserManagementTabsPage} from '../pages/user-management-tabs/user-management-tabs';
import {UsersPage} from '../pages/users/users';
import {UsersAddPopup} from '../pages/users-add-popup/users-add-popup';
import {DropshipLocationAddPopup} from '../pages/dropship-location-add-popup/dropship-location-add-popup'
import {ItemsModalPage} from '../pages/items-modal/items-modal';

import {BookmarksPage} from '../pages/bookmarks/bookmarks';

import {ComingSoon} from '../pages/coming-soon/coming-soon';

import {InternetCheckPopupPage} from '../pages/internet-check-popup/internet-check-popup';

import {HttpModule} from '@angular/http';
import {TokenManager} from '../providers/token-manager';

import {SignaturePadModule} from 'angular2-signaturepad';
import {IonicStorageModule} from '@ionic/storage';
import {MsgManager} from '../providers/msg-manager';
import {ReportsPage} from '../pages/reports/reports';


import {IonicImageLoader} from 'ionic-image-loader';
// end import pages
import {BarcodeModalPage} from '../pages/barcode-modal/barcode-modal';

import {BrowserModule} from '@angular/platform-browser';
import {DatePickerModule} from 'ionic2-date-picker';
import {SentryErrorHandler} from '../services/sentry-error-handler';
import {GVLogger} from '../services/gv-logger';
import {DatabaseProvider} from '../providers/database/database';

import {WebstoreUserSelfEditPage} from '../pages/webstore-user-self-edit/webstore-user-self-edit';

import {ThankYouModalPage} from '../pages/thank-you-modal/thank-you-modal';
import {Network} from '@ionic-native/network';
import {ExpandableListComponent} from '../components/expandable-list/expandable-list';
import { CommonDataProvider } from '../providers/common-data/common-data';
// import { SQLite } from 'ionic-native';
import {  SQLite } from '@ionic-native/sqlite';
// import { PickPackParamsPage } from '../pages/pickpackparams/pickpackparams';
// import { PickpacklistPage } from '../pages/pickpacklist/pickpacklist';
// import { StockcartPage } from '../pages/stockcart/stockcart';
// import { StockcartManager } from '../providers/stockcart-manager';
// import { customFieldsProvider } from '../providers/params';
import { LicenseStatusModelPage } from '../pages/license-status-model/license-status-model';
// import { ProductLocationsModelPage } from '../pages/product-locations-model/product-locations-model';
import { LocationCodeModelPage } from '../pages/location-code-model/location-code-model';
// import { BrMaskerModule } from 'brmasker-ionic-3';
// import { LayoutService } from '../../layout/layout.service';
// import { MatSnackBar } from '@angular/material';
// import { Router } from '@angular/router';

import { IonicSelectableModule } from 'ionic-selectable';
// import {ReceiveStockPopupPage} from "../pages/receive-stock-popup/receive-stock-popup";
import {ReferenceListPage} from "../pages/reference-list/reference-list";
// import {ConfirmShipmentPage} from "../pages/confirm-shipment/confirm-shipment";
// import { ShipmentcartManagerProvider } from '../providers/shipmentcart-manager';
import { LocationsListPage } from '../pages/locations-list/locations-list';
import { EditorModule } from '@tinymce/tinymce-angular';
// import {MoveStockCartPage} from "../pages/move-stock-cart/move-stock-cart";
// import {MovestockcartManager} from "../providers/movestockcart-manager";
import { SortByPipe } from '../pipes/sort-by/sort-by';
import { FileUploadModule } from 'ng2-file-upload';
import {IonicInputMaskModule} from "@thiagoprz/ionic-input-mask";
import {TextMaskModule} from "angular2-text-mask";
import {ConfirmPasswordPopup} from "../pages/confirm-password-popup/confirm-password-popup";
import { PhoneNumberMaskDirective } from "../providers/phoneMask.directive"


@NgModule({
  declarations: [
    PhoneNumberMaskDirective,
    MyApp,
    CartPage,
    // CategoriesPage,
    ItemsPage,
    ChangePasswordPage,
    CreateCustomerPage,
    ForgotPasswordPage,
    HomePage,
    ItemPage,
    LoginPage,
    MyAccountPage,
    MyOrderPage,
    OrderConfirmPage,
    RegisterPage,
    SearchPage,
    SearchCustomersPage,
    SettingsPage,
    WelcomePage,
    CustomerWishListPage,
    ListCustomersPage,
    CustomerDetailPage,
    EditCustomerPage,
    OrderViewPage,
    AppImageCache,
    DashBoardPage,

    ReportsPage,
    ClosedsalesPage,
    BysalesrepPage,
    TrendingproductsPage,

    SelectionSearchPage,
    ComingSoon,
    WebstoreUsersPage,
    WebstoreUserAddPage,
    WebstoreUserAddPopup,
    CategoriesPage,
    ClassesPage,
    CategoriesTabsPage,
    UserManagementTabsPage,
    UsersPage,
    UsersAddPopup,
    DropshipLocationAddPopup,
    ConfirmPasswordPopup,
    BarcodeModalPage,
    ItemsModalPage,
    BookmarksPage,
    InternetCheckPopupPage,
    ThankYouModalPage,
    WebstoreUserSelfEditPage,
    // PickPackParamsPage,
    // PickpacklistPage,
    // StockcartPage,
    ExpandableListComponent,
    LicenseStatusModelPage,
    // ProductLocationsModelPage,
    LocationCodeModelPage,
    // ReceiveStockPopupPage,
    ReferenceListPage,
    // ConfirmShipmentPage,
    LocationsListPage,
    // MoveStockCartPage,
    SortByPipe,
    SortByPipe

  ],
  imports: [
    FileUploadModule,
    BrowserModule,
    IonicModule.forRoot(MyApp),
    SignaturePadModule,
    HttpModule,
    IonicImageLoader.forRoot(),
    IonicStorageModule.forRoot(),
    DatePickerModule,
    IonicSelectableModule,
    EditorModule,
    IonicInputMaskModule,
    TextMaskModule,

    // BrMaskerModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    CartPage,
    //CategoriesPage,
    ItemsPage,
    ChangePasswordPage,
    CreateCustomerPage,
    ForgotPasswordPage,
    HomePage,
    ItemPage,
    LoginPage,

    ReportsPage,
    ClosedsalesPage,
    BysalesrepPage,
    TrendingproductsPage,

    MyAccountPage,
    MyOrderPage,
    OrderConfirmPage,
    RegisterPage,
    SearchPage,
    SearchCustomersPage,
    SettingsPage,
    WelcomePage,
    CustomerWishListPage,
    ListCustomersPage,
    CustomerDetailPage,
    EditCustomerPage,
    OrderViewPage,
    DashBoardPage,

    SelectionSearchPage,
    ComingSoon,
    WebstoreUsersPage,
    WebstoreUserAddPage,
    WebstoreUserAddPopup,
    CategoriesPage,
    ClassesPage,
    CategoriesTabsPage,
    UserManagementTabsPage,
    UsersPage,
    UsersAddPopup,
    DropshipLocationAddPopup,
    ConfirmPasswordPopup,
    BarcodeModalPage,
    ItemsModalPage,
    BookmarksPage,
    InternetCheckPopupPage,
    ThankYouModalPage,
    WebstoreUserSelfEditPage,
    // PickPackParamsPage,
    // PickpacklistPage,
    // StockcartPage,
    LicenseStatusModelPage,
    // ProductLocationsModelPage,
    LocationCodeModelPage,
    // ReceiveStockPopupPage,
    ReferenceListPage,
    // ConfirmShipmentPage,
    LocationsListPage,
    // MoveStockCartPage

  ],
  providers: [
    Api,
    ArrayUtils,
    CartManager,
    // StockcartManager,
    // MovestockcartManager,
    Settings,
    GVLogger,
    SelectionSearchService,
    MsgManager,
    TokenManager
    , {provide: ErrorHandler, useClass: SentryErrorHandler},
    FabContainer,
    ApiOffline,
    DatabaseProvider,
    Network,
    CommonDataProvider,
    SQLite,
    // customFieldsProvider,
    // ShipmentcartManagerProvider,
    /* import services */
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts